import { memo } from "react";

import { TableCellValue, TableMetrics } from "../../types";
import VisibilityValue from "../ValueRenderers/VisibilityValue";
import NumberValue from "../ValueRenderers/NumberValue";

import styles from "./TableCell.module.css";

type TableCellMobileValueProps = {
  value: TableCellValue | null;
  onOpenResponse: (responseId: string, metrics?: TableMetrics) => void;
};

const TableCellMobileValue = memo(function TableCellMobileValue({
  value,
  onOpenResponse,
}: TableCellMobileValueProps) {
  const { metrics, response, loader } = value || {};

  return (
    <div className={styles["table__mobile-value"]}>
      {response && (
        <button
          type="button"
          className={styles["table__mobile-response"]}
          onClick={() => onOpenResponse(response, metrics)}
        >
          View response
        </button>
      )}

      <div className={styles["table__mobile-metric-row"]}>
        <span className={styles["table__mobile-metric-label"]}>Visibility</span>
        <span className={styles["table__mobile-metric-value"]}>
          <VisibilityValue value={metrics?.visibility} loader={loader} />
        </span>
      </div>

      <div className={styles["table__mobile-metric-row"]}>
        <span className={styles["table__mobile-metric-label"]}>Sentiment</span>
        <span className={styles["table__mobile-metric-value"]}>
          <NumberValue value={metrics?.sentiment} loader={loader} />
        </span>
      </div>

      <div className={styles["table__mobile-metric-row"]}>
        <span className={styles["table__mobile-metric-label"]}>Ranking</span>
        <span className={styles["table__mobile-metric-value"]}>
          <NumberValue value={metrics?.ranking} loader={loader} />
        </span>
      </div>
    </div>
  );
});

export default TableCellMobileValue;

